export enum ClientMessageModalActions {
    Up = 'Up',
    Down = 'Down',
    Confirm = 'Confirm',
    SkipMessage = 'SkipMessage',
};
